import { render, staticRenderFns } from "./rma_history_table.vue?vue&type=template&id=a6e6e1f6&scoped=true&"
import script from "./rma_history_table.vue?vue&type=script&lang=js&"
export * from "./rma_history_table.vue?vue&type=script&lang=js&"
import style0 from "./rma_history_table.vue?vue&type=style&index=0&id=a6e6e1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e6e1f6",
  null
  
)

export default component.exports